import type { Catalogue } from './en';

// Malayalam catalogue. Drafted for the scaffold; a native Malayalam editor must review it
// before any mahallu sees it (tracked in docs/pending-tasks.md).
export const ml: Catalogue = {
  'app.name': 'Rabita One (റാബിത വൺ)',
  'app.devBanner': 'ഡെവലപ്‌മെന്റ് പതിപ്പ്: സാമ്പിൾ വിവരങ്ങൾ; സൈൻ-ഇൻ കോഡ് API കൺസോളിൽ കാണാം.',

  'nav.overview': 'അവലോകനം',
  'nav.dashboard': 'ഡാഷ്‌ബോർഡ്',
  'nav.community': 'സമൂഹം',
  'nav.register': 'അംഗ രജിസ്റ്റർ',
  'nav.register.members': 'അംഗ മാനേജ്‌മെന്റ്',
  'nav.register.lifeEvents': 'ജീവിത സംഭവങ്ങൾ',
  'nav.register.pravasi': 'പ്രവാസി രജിസ്റ്റർ',
  'nav.register.wards': 'വാർഡുകൾ',
  'nav.register.transfers': 'ട്രാൻസ്ഫർ',
  'nav.register.documents': 'രേഖകൾ',
  'nav.register.idCards': 'ഐഡി കാർഡുകൾ',
  'nav.register.selfRegistration': 'സ്വയം രജിസ്ട്രേഷൻ',
  'nav.varisankhya': 'വരിസംഖ്യ',
  'nav.varisankhya.dues': 'കുടിശ്ശിക',
  'nav.varisankhya.collect': 'പിരിവ്',
  'nav.varisankhya.receipts': 'രസീതുകൾ',
  'nav.varisankhya.plans': 'നിരക്കുകൾ',
  'nav.certificates': 'സർട്ടിഫിക്കറ്റുകൾ',
  'nav.certificates.requests': 'അപേക്ഷകൾ',
  'nav.certificates.issued': 'നൽകിയവ',
  'nav.madrasa': 'മദ്രസ',
  'nav.madrasa.students': 'വിദ്യാർത്ഥികൾ',
  'nav.madrasa.attendance': 'ഹാജർ',
  'nav.engage': 'ആശയവിനിമയം',
  'nav.communication': 'ആശയവിനിമയം',
  'nav.communication.announcements': 'അറിയിപ്പുകൾ',
  'nav.communication.send': 'സന്ദേശം അയക്കുക',
  'nav.notifications': 'നോട്ടിഫിക്കേഷനുകൾ',
  'nav.approvals': 'അംഗീകാരങ്ങൾ',
  'nav.administration': 'ഭരണം',
  'nav.accounts': 'കണക്കുകളും വഖഫും',
  'nav.committee': 'കമ്മിറ്റി',
  'nav.settings': 'ക്രമീകരണങ്ങൾ',
  'form.save': 'സേവ് ചെയ്യുക',
  'form.cancel': 'റദ്ദാക്കുക',
  'form.saving': 'സേവ് ചെയ്യുന്നു…',
  'form.choose': 'തിരഞ്ഞെടുക്കുക…',
  'form.phoneHint': 'ഇന്ത്യൻ മൊബൈൽ +91 ഇല്ലാതെ നൽകാം. വിദേശ നമ്പറിന് രാജ്യ കോഡ് വേണം.',
  'house.add': 'വീട് ചേർക്കുക',
  'house.edit': 'വീട് തിരുത്തുക',
  'house.section': 'വീട്',
  'house.headSection': 'കുടുംബനാഥൻ',
  'house.numberPreview': 'ഈ വീടിന്റെ നമ്പർ {{no}} ആയിരിക്കും.',
  'house.consentNote': 'സമ്മതം ആദ്യം "ബാക്കി" ആയിരിക്കും. കുടുംബം ഒപ്പിടുമ്പോൾ രേഖപ്പെടുത്തുക (ഘട്ടം 5).',
  'house.statusHint': 'വീട് ഒരിക്കലും നീക്കം ചെയ്യില്ല. കുടുംബം താമസം മാറുമ്പോൾ "താമസം മാറി" ആക്കുക.',
  'field.personEn': 'പേര് (ഇംഗ്ലീഷ്)',
  'field.personMl': 'പേര് (മലയാളം)',
  'field.gender': 'ലിംഗം',
  'gender.M': 'പുരുഷൻ',
  'gender.F': 'സ്ത്രീ',
  'field.birthYear': 'ജനന വർഷം',
  'field.countryOnly': 'രാജ്യം',
  'field.stateOnly': 'സംസ്ഥാനം',
  'field.regionAbroad': 'എമിറേറ്റ് / പ്രവിശ്യ',
  'field.monthlyRate': 'പ്രതിമാസ തുക (₹)',
  'field.status': 'സ്ഥിതി',
  'member.add': 'അംഗത്തെ ചേർക്കുക',
  'member.edit': 'അംഗത്തെ തിരുത്തുക',
  'member.section': 'അംഗം',
  'member.statusHint': 'ആരെയും നീക്കം ചെയ്യില്ല. മരണം, വിവാഹം വഴി പോകൽ, താമസം മാറൽ എന്നിവയ്ക്ക് സ്ഥിതി മാറ്റുക.',
  'mstatus.ALIVE': 'ജീവിച്ചിരിക്കുന്നു',
  'mstatus.DECEASED': 'മരണപ്പെട്ടു',
  'mstatus.MARRIED_OUT': 'വിവാഹം വഴി പോയി',
  'mstatus.TRANSFERRED': 'ട്രാൻസ്ഫർ ചെയ്തു',
  'wards.title': 'വാർഡുകൾ',
  'wards.desc': 'മഹല്ലിനുള്ളിലെ പ്രദേശങ്ങൾ. ഓരോ വാർഡിനും സ്വന്തം വീട്ടു നമ്പറുകൾ.',
  'wards.add': 'വാർഡ് ചേർക്കുക',
  'wards.rename': 'വാർഡിന്റെ പേര് മാറ്റുക',
  'wards.section': 'വാർഡ്',
  'wards.code': 'കോഡ്',
  'wards.nameEn': 'പേര് (ഇംഗ്ലീഷ്)',
  'wards.nameMl': 'പേര് (മലയാളം)',
  'wards.codeHint': 'ചെറുതും സ്ഥിരവും, ഉദാ. W5. ഇത് വീട്ടു നമ്പറിൽ വരും.',
  'wards.codeFixed': 'കോഡ് വീട്ടു നമ്പറിന്റെ ഭാഗമാണ്; മാറ്റാനാവില്ല.',
  'wards.nextHouse': 'അടുത്ത വീട്ടു നമ്പർ',
  'nav.settings.sequences': 'നമ്പറിംഗ്',
  'seq.title': 'നമ്പറിംഗ്',
  'seq.desc': 'റാബിത വൺ നൽകുന്ന എല്ലാ നമ്പറുകളും ഇവിടെ നിന്നാണ്: വീട്ടു നമ്പർ, രസീത്, സർട്ടിഫിക്കറ്റ്. ഒരു നമ്പർ രണ്ടുതവണ നൽകില്ല.',
  'seq.pattern': 'മാതൃക',
  'seq.tokens': 'ടോക്കണുകൾ: {YYYY} വർഷം · {YY} ചുരുക്കിയ വർഷം · {MM} മാസം · {WARD} വാർഡ് · {SEQ4} 4 അക്ക തുടർ നമ്പർ (3 മുതൽ 8 വരെ).',
  'seq.reset': 'വീണ്ടും 1 മുതൽ',
  'seq.reset.NEVER': 'ഒരിക്കലുമില്ല',
  'seq.reset.YEARLY': 'എല്ലാ വർഷവും (ജനുവരി 1)',
  'seq.reset.MONTHLY': 'എല്ലാ മാസവും',
  'seq.scope.WARD': 'ഓരോ വാർഡിലും വെവ്വേറെ നമ്പർ',
  'seq.preview': 'അടുത്ത നമ്പർ ഇങ്ങനെയായിരിക്കും',
  'seq.next': 'അടുത്ത നമ്പർ',
  'seq.save': 'മാതൃക സേവ് ചെയ്യുക',
  'seq.saved': 'സേവ് ചെയ്തു.',
  'seq.resetHint': 'ആദ്യ നമ്പർ നൽകുന്നതിന് മുമ്പ് മാത്രമേ പുനരാരംഭ നിയമം മാറ്റാനാകൂ.',
  'seq.raise': 'ഇവിടെ നിന്ന് തുടരുക',
  'seq.raiseHint': 'കടലാസ് പുസ്തകത്തിൽ നിന്ന് തുടരാൻ അടുത്ത നമ്പർ ഇവിടെ നൽകുക. അത് ഉയർത്താനേ കഴിയൂ, കുറയ്ക്കാനാവില്ല.',
  'seq.set': 'നൽകുക',
  'seq.ward': 'വാർഡ്',
  'seq.readOnly': 'സെക്രട്ടറിക്കോ മഹല്ല് അഡ്മിനോ മാത്രമേ നമ്പറിംഗ് മാറ്റാനാകൂ.',

  'header.search': 'വീടുകൾ, അംഗങ്ങൾ, രസീതുകൾ തിരയുക',
  'header.notifications': 'നോട്ടിഫിക്കേഷനുകൾ',
  'header.language': 'ഭാഷ',

  'dash.greeting': 'അസ്സലാമു അലൈക്കും',
  'dash.subtitle': 'ഇന്നത്തെ മഹല്ല് വിവരങ്ങൾ.',
  'dash.houses': 'വീടുകൾ',
  'dash.members': 'അംഗങ്ങൾ',
  'dash.pravasiHouses': 'പ്രവാസികളുള്ള വീടുകൾ',
  'dash.arrearsHouses': '3+ മാസം കുടിശ്ശികയുള്ള വീടുകൾ',
  'dash.openRegister': 'അംഗ രജിസ്റ്റർ തുറക്കുക',

  'mm.title': 'അംഗ മാനേജ്‌മെന്റ്',
  'mm.desc': 'മഹല്ലിലെ എല്ലാ വീടുകളും: കുടുംബം, ഓരോ അംഗവും താമസിക്കുന്ന സ്ഥലം, വരിസംഖ്യ നിരക്ക്, രേഖകൾ.',
  'mm.exportAll': 'എല്ലാം എക്സ്പോർട്ട്',
  'mm.currentView': 'ഈ കാഴ്ച',
  'mm.import': 'ഇംപോർട്ട്',
  'mm.wards': 'വാർഡുകൾ',
  'mm.ratePlans': 'നിരക്കുകൾ',
  'mm.dataHealth': 'വിവര പരിശോധന',
  'mm.addHouse': 'വീട് ചേർക്കുക',
  'mm.notYet': 'ഈ സൗകര്യം അടുത്ത ഘട്ടത്തിൽ വരും.',

  'f.ward': 'വാർഡ്',
  'f.allWards': 'എല്ലാ വാർഡുകളും',
  'f.status': 'സ്ഥിതി',
  'f.allStatus': 'എല്ലാ സ്ഥിതിയും',
  'f.residence': 'താമസം',
  'f.anyResidence': 'ഏത് താമസവും',
  'f.hasPravasi': 'പ്രവാസികളുള്ളവ',
  'f.hasOtherState': 'മറ്റു സംസ്ഥാനങ്ങളിലുള്ളവ',
  'f.allResident': 'എല്ലാവരും നാട്ടിൽ',
  'f.count': '{{count}} വീടുകൾ',
  'f.count_one': '{{count}} വീട്',

  'tile.all': 'ആകെ വീടുകൾ',
  'tile.members': 'അംഗങ്ങൾ',
  'tile.pravasi': 'പ്രവാസികളുള്ള വീടുകൾ',
  'tile.other': 'മറ്റു സംസ്ഥാനങ്ങളിൽ അംഗങ്ങളുള്ള വീടുകൾ',
  'tile.phone': 'ഫോൺ സ്ഥിരീകരിച്ചിട്ടില്ല',
  'tile.consent': 'സമ്മതം ബാക്കി',
  'tile.arrears': '3+ മാസം കുടിശ്ശിക',
  'tile.fix': 'ശരിയാക്കുക',

  'col.house': 'വീട്',
  'col.head': 'കുടുംബനാഥൻ',
  'col.ward': 'വാർഡ്',
  'col.members': 'അംഗങ്ങൾ',
  'col.plan': 'നിരക്ക്',
  'col.arrears': 'കുടിശ്ശിക',
  'col.phone': 'ഫോൺ',
  'col.status': 'സ്ഥിതി',
  'col.actions': 'പ്രവർത്തനങ്ങൾ',

  'table.search': 'വീട്ടുപേര്, നമ്പർ, കുടുംബനാഥൻ എന്നിവ തിരയുക…',
  'table.columns': 'കോളങ്ങൾ',
  'table.perPage': 'ഒരു പേജിൽ {{n}}',
  'table.showing': '{{total}} ൽ {{from}}–{{to}}',
  'table.empty': 'ഈ ഫിൽട്ടറിൽ ഒന്നുമില്ല. തിരയൽ മാറ്റുക അല്ലെങ്കിൽ മറ്റൊരു ടൈൽ തിരഞ്ഞെടുക്കുക.',
  'table.loading': 'രജിസ്റ്റർ ലോഡ് ചെയ്യുന്നു…',
  'table.error': 'രജിസ്റ്റർ ലോഡ് ചെയ്യാനായില്ല. API പ്രവർത്തിക്കുന്നുണ്ടോ എന്ന് നോക്കി വീണ്ടും ശ്രമിക്കുക.',
  'table.signedOut': 'നിങ്ങളുടെ സൈൻ-ഇൻ അവസാനിച്ചു. വീണ്ടും സൈൻ ഇൻ ചെയ്യുക.',
  'table.forbidden': 'ഇത് കാണാൻ നിങ്ങൾക്ക് അനുമതിയില്ല.',
  'table.retry': 'വീണ്ടും ശ്രമിക്കുക',
  'table.view': 'വീട് കാണുക',

  'badge.verified': 'സ്ഥിരീകരിച്ചു',
  'badge.notVerified': 'സ്ഥിരീകരിച്ചിട്ടില്ല',
  'badge.abroad': '{{n}} വിദേശത്ത്',
  'badge.otherState': '{{n}} മറ്റു സംസ്ഥാനം',

  'status.ACTIVE': 'സജീവം',
  'status.MOVED_OUT': 'താമസം മാറി',
  'plan.STANDARD': 'സാധാരണ',
  'plan.NRI': 'പ്രവാസി',
  'plan.EXEMPT': 'ഒഴിവ്',
  'consent.GIVEN': 'നൽകി',
  'consent.PENDING': 'ബാക്കി',
  'unit.perMonth': '/മാസം',
  'unit.months': '{{n}} മാസം',

  'tab.overview': 'അവലോകനം',
  'tab.members': 'അംഗങ്ങൾ',
  'tab.residence': 'താമസം',
  'tab.varisankhya': 'വരിസംഖ്യ',
  'tab.certificates': 'സർട്ടിഫിക്കറ്റുകൾ',
  'tab.madrasa': 'മദ്രസ',
  'tab.documents': 'രേഖകൾ',
  'tab.notes': 'കുറിപ്പുകൾ',
  'tab.history': 'ചരിത്രം',
  'drawer.close': 'അടയ്ക്കുക',
  'drawer.memberCount': '{{n}} അംഗങ്ങൾ',
  'drawer.arrearsNote': 'കുടിശ്ശിക വിവരത്തിന് മാത്രം. സർട്ടിഫിക്കറ്റ്, ഖബറടക്കം, മദ്രസ പ്രവേശനം എന്നിവ ഇത് കാരണം തടയില്ല. കമ്മിറ്റി തീരുമാനിക്കും.',
  'drawer.comingLater': 'ഈ ഭാഗം അതിന്റെ മൊഡ്യൂൾ തയ്യാറാകുമ്പോൾ നിറയും.',
  'drawer.allResident': 'ഈ വീട്ടിലെ എല്ലാവരും മഹല്ലിൽ തന്നെ താമസിക്കുന്നു.',
  'drawer.loading': 'വീടിന്റെ വിവരങ്ങൾ ലോഡ് ചെയ്യുന്നു…',

  'field.houseNo': 'വീട്ടു നമ്പർ',
  'field.ward': 'വാർഡ്',
  'field.nameEn': 'വീട്ടുപേര് (ഇംഗ്ലീഷ്)',
  'field.nameMl': 'വീട്ടുപേര് (മലയാളം)',
  'field.head': 'കുടുംബനാഥൻ',
  'field.ownership': 'ഉടമസ്ഥത',
  'field.plan': 'വരിസംഖ്യ നിരക്ക്',
  'field.consent': 'വിവര ഉപയോഗ സമ്മതം',
  'field.name': 'പേര്',
  'field.relation': 'ബന്ധം',
  'field.born': 'ജനന വർഷം',
  'field.lives': 'താമസം',
  'field.phone': 'ഫോൺ',
  'field.country': 'രാജ്യം / സംസ്ഥാനം',
  'field.city': 'നഗരം',
  'field.work': 'ജോലി',

  'ownership.OWN': 'സ്വന്തം വീട്',
  'ownership.RENTED': 'വാടക',
  'rel.HEAD': 'കുടുംബനാഥൻ',
  'rel.WIFE': 'ഭാര്യ',
  'rel.HUSBAND': 'ഭർത്താവ്',
  'rel.SON': 'മകൻ',
  'rel.DAUGHTER': 'മകൾ',
  'rel.FATHER': 'പിതാവ്',
  'rel.MOTHER': 'മാതാവ്',
  'rel.OTHER': 'മറ്റുള്ളവർ',
  'res.RESIDENT': 'നാട്ടിൽ',
  'res.OTHER_STATE': 'മറ്റു സംസ്ഥാനം',
  'res.ABROAD': 'വിദേശത്ത്',

  'signin.steps': 'സൈൻ ഇൻ ഘട്ടങ്ങൾ',
  'signin.stepNumber': 'നിങ്ങളുടെ നമ്പർ',
  'signin.stepCode': 'കോഡ്',
  'signin.stepVerify': 'ഓതന്റിക്കേറ്റർ',
  'signin.sending': 'അയയ്ക്കുന്നു…',
  'signin.title': 'നിങ്ങളുടെ മഹല്ലിൽ സൈൻ ഇൻ ചെയ്യുക',
  'signin.subtitle': 'നിങ്ങളുടെ ഫോണിലേക്കോ ഇമെയിലിലേക്കോ ഒറ്റത്തവണ കോഡ് അയക്കും.',
  'signin.identifier': 'മൊബൈൽ നമ്പർ അല്ലെങ്കിൽ ഇമെയിൽ',
  'signin.identifierHint': 'ഇന്ത്യൻ നമ്പറുകൾ +91 ഇല്ലാതെ നൽകാം. വിദേശ നമ്പറുകൾക്ക് രാജ്യ കോഡ് വേണം.',
  'signin.channel': 'കോഡ് അയക്കേണ്ട വഴി',
  'channel.WHATSAPP': 'വാട്ട്‌സ്ആപ്പ്',
  'channel.SMS': 'എസ്എംഎസ്',
  'channel.EMAIL': 'ഇമെയിൽ',
  'signin.sendCode': 'കോഡ് അയക്കുക',
  'signin.codeTitle': 'കോഡ് നൽകുക',
  'signin.codeSent': '{{channel}} വഴി {{destination}} ലേക്ക് 6 അക്ക കോഡ് അയച്ചു.',
  'signin.code': '6 അക്ക കോഡ്',
  'signin.continue': 'തുടരുക',
  'signin.resend': 'പുതിയ കോഡ് അയക്കുക',
  'signin.resendIn': '{{n}} സെക്കൻഡിന് ശേഷം പുതിയ കോഡ് ചോദിക്കാം.',
  'signin.trySms': 'പകരം എസ്എംഎസ് വഴി അയക്കുക',
  'signin.change': 'മറ്റൊരു നമ്പറോ ഇമെയിലോ ഉപയോഗിക്കുക',
  'signin.devHint': 'ഡെവലപ്‌മെന്റ് പതിപ്പ്: കോഡ് അയക്കില്ല, API കൺസോളിൽ കാണിക്കും (DEV_FIXED_OTP ഉണ്ടെങ്കിൽ 000000).',
  'signin.codeWrong': 'കോഡ് ശരിയല്ല. ഇനി {{n}} ശ്രമങ്ങൾ.',
  'signin.codeExpired': 'ഈ കോഡിന്റെ സമയം കഴിഞ്ഞു അല്ലെങ്കിൽ ഉപയോഗിച്ചു. പുതിയ കോഡ് ചോദിക്കുക.',
  'signin.tooMany': 'ശ്രമങ്ങൾ കൂടുതലായി. അൽപ്പം കഴിഞ്ഞ് വീണ്ടും ശ്രമിക്കുക.',
  'signin.error': 'എന്തോ പിശക് സംഭവിച്ചു. വീണ്ടും ശ്രമിക്കുക.',
  'signin.chooseTitle': 'മഹല്ല് തിരഞ്ഞെടുക്കുക',
  'signin.chooseBody': 'നിങ്ങൾ ഒന്നിലധികം മഹല്ലുകളിൽ അംഗമാണ്. തുറക്കേണ്ടത് തിരഞ്ഞെടുക്കുക.',
  'mfa.title': 'രണ്ട്-ഘട്ട സൈൻ-ഇൻ',
  'mfa.setupBody': 'കമ്മിറ്റി അക്കൗണ്ടുകൾക്ക് Google Authenticator, Microsoft Authenticator പോലുള്ള ഓതന്റിക്കേറ്റർ ആപ്പ് വേണം. ഈ കോഡ് ആപ്പിൽ സ്കാൻ ചെയ്ത്, ആപ്പ് കാണിക്കുന്ന 6 അക്ക കോഡ് നൽകുക.',
  'mfa.manualKey': 'അല്ലെങ്കിൽ ഈ കീ ആപ്പിൽ ടൈപ്പ് ചെയ്യുക:',
  'mfa.enterBody': 'ഓതന്റിക്കേറ്റർ ആപ്പിലെ 6 അക്ക കോഡ് നൽകുക.',
  'mfa.code': 'ഓതന്റിക്കേറ്റർ കോഡ്',
  'mfa.verify': 'സ്ഥിരീകരിക്കുക',
  'mfa.loading': 'ഓതന്റിക്കേറ്റർ കോഡ് തയ്യാറാക്കുന്നു…',
  'member.title': 'അംഗങ്ങൾ Rabita One ആപ്പ് ഉപയോഗിക്കുക',
  'member.body': 'ഈ സ്ക്രീൻ മഹല്ല് കമ്മിറ്റിക്കുള്ളതാണ്. കുടുംബങ്ങൾക്കുള്ള ആപ്പ് അടുത്തതായി വരും.',
  'header.signOut': 'സൈൻ ഔട്ട്',
  'role.MAHALLU_ADMIN': 'മഹല്ല് അഡ്മിൻ',
  'role.PRESIDENT': 'പ്രസിഡന്റ്',
  'role.SECRETARY': 'സെക്രട്ടറി',
  'role.TREASURER': 'ട്രഷറർ',
  'role.COLLECTOR': 'പിരിവുകാരൻ',
  'role.WARD_REP': 'വാർഡ് പ്രതിനിധി',
  'role.SADR': 'സദർ ഉസ്താദ്',
  'role.USTHAD': 'ഉസ്താദ്',
  'role.MEMBER': 'അംഗം',

  'nav.settings.users': 'ഉപയോക്താക്കളും ചുമതലകളും',
  'header.account': 'അക്കൗണ്ട്',
  'header.actAs': 'ഈ ചുമതലയിൽ',
  'header.sessions': 'സജീവ സൈൻ-ഇനുകൾ',
  'users.title': 'ഉപയോക്താക്കളും ചുമതലകളും',
  'users.desc': 'ഈ മഹല്ലിൽ ആർക്കൊക്കെ ഏത് ചുമതലയിൽ സൈൻ ഇൻ ചെയ്യാം. വാർഡ് പ്രതിനിധികളും പിരിവുകാരും അവരുടെ വാർഡ് മാത്രം കാണും.',
  'users.invite': 'പ്രവേശനം നൽകുക',
  'users.person': 'വ്യക്തി',
  'users.roles': 'ചുമതലകൾ',
  'users.twoStep': 'ഓതന്റിക്കേറ്റർ',
  'users.twoStepOn': 'സജ്ജമാണ്',
  'users.twoStepOff': 'സജ്ജമല്ല',
  'users.lastSeen': 'അവസാനം സജീവം',
  'users.status': 'പ്രവേശനം',
  'users.ACTIVE': 'സജീവം',
  'users.REVOKED': 'നീക്കി',
  'users.you': 'നിങ്ങൾ',
  'users.never': 'ഇതുവരെ ഇല്ല',
  'users.manage': 'പ്രവേശനം കൈകാര്യം ചെയ്യുക',
  'users.loading': 'ആളുകളെ ലോഡ് ചെയ്യുന്നു…',
  'users.section': 'വ്യക്തി',
  'users.identifier': 'മൊബൈൽ നമ്പർ അല്ലെങ്കിൽ ഇമെയിൽ',
  'users.identifierHint': 'ഇതിലേക്ക് അയക്കുന്ന ഒറ്റത്തവണ കോഡ് ഉപയോഗിച്ച് അവർ സൈൻ ഇൻ ചെയ്യും. ഇന്ത്യൻ നമ്പറുകൾ +91 ഇല്ലാതെ നൽകാം.',
  'users.name': 'പേര്',
  'users.role': 'ചുമതല',
  'users.ward': 'വാർഡ്',
  'users.wardHint': 'വാർഡ് പ്രതിനിധിയോ പിരിവുകാരനോ ഈ വാർഡ് മാത്രം കാണും.',
  'users.rolesSection': 'വഹിക്കുന്ന ചുമതലകൾ',
  'users.addRole': 'ചുമതല ചേർക്കുക',
  'users.removeRole': 'ചുമതല നീക്കുക',
  'users.mfaSection': 'ഓതന്റിക്കേറ്റർ ആപ്പ്',
  'users.resetMfa': 'ഓതന്റിക്കേറ്റർ പുനഃസജ്ജമാക്കുക',
  'users.resetMfaHint': 'ഫോൺ നഷ്ടപ്പെടുകയോ മാറുകയോ ചെയ്താൽ. അടുത്ത സൈൻ-ഇനിൽ അവർ പുതിയത് സജ്ജമാക്കും.',
  'users.accessSection': 'പ്രവേശനം',
  'users.revoke': 'പ്രവേശനം നീക്കുക',
  'users.revokeHint': 'ഈ മഹല്ലിലെ അവരുടെ എല്ലാ സൈൻ-ഇനുകളും ഉടൻ അവസാനിക്കും.',
  'users.restore': 'പ്രവേശനം തിരികെ നൽകുക',
  'users.restoreHint': 'ഇവരുടെ പ്രവേശനം നീക്കിയിരുന്നു. തിരികെ നൽകിയാൽ മുകളിലെ ചുമതലകൾ തിരിച്ചുവരും.',
  'users.confirm': 'ഉറപ്പാണോ?',
  'users.yes': 'അതെ',
  'users.no': 'വേണ്ട',
  'users.done': 'കഴിഞ്ഞു',
  'sessions.title': 'സജീവ സൈൻ-ഇനുകൾ',
  'sessions.desc': 'നിങ്ങൾ സൈൻ ഇൻ ചെയ്തിട്ടുള്ള എല്ലാ ഉപകരണങ്ങളും. തിരിച്ചറിയാത്തവ അവസാനിപ്പിക്കുക.',
  'sessions.endOthers': 'മറ്റെല്ലായിടത്തുനിന്നും സൈൻ ഔട്ട് ചെയ്യുക',
  'sessions.device': 'ഉപകരണം',
  'sessions.mahallu': 'മഹല്ല്',
  'sessions.role': 'ചുമതല',
  'sessions.started': 'സൈൻ ഇൻ ചെയ്തത്',
  'sessions.lastSeen': 'അവസാനം സജീവം',
  'sessions.thisDevice': 'ഈ ഉപകരണം',
  'sessions.end': 'അവസാനിപ്പിക്കുക',
  'sessions.ended': 'മറ്റ് {{n}} സൈൻ-ഇനുകൾ അവസാനിപ്പിച്ചു.',
  'sessions.loading': 'സൈൻ-ഇനുകൾ ലോഡ് ചെയ്യുന്നു…',

  'member.continueAs': '{{role}} ആയി തുടരുക',

  // Profile, brand, settings, audit log (pilot slice 11)
  'app.descriptor': 'OptiFi-യുടെ മഹല്ല് ക്ലൗഡ്',
  'app.tagline': 'എല്ലാ മഹല്ലുകളും, ഒന്നിച്ച്.',
  'nav.settings.profile': 'മഹല്ല് പ്രൊഫൈൽ',
  'nav.settings.app': 'ആപ്പ് ക്രമീകരണങ്ങൾ',
  'nav.settings.audit': 'ഓഡിറ്റ് ലോഗ്',
  'print.waqf': 'വഖഫ് ബോർഡ് രജി. നമ്പർ',
  'profile.title': 'മഹല്ല് പ്രൊഫൈൽ',
  'profile.desc': 'മഹല്ലിന്റെ പേര്, വിലാസം, രജിസ്ട്രേഷനുകൾ, നിറം, മുദ്ര. രസീതുകളിലും സർട്ടിഫിക്കറ്റുകളിലും പൊതു പേജുകളിലും ഇവ കാണിക്കും.',
  'profile.identity': 'പേരും വിലാസവും',
  'profile.nameEn': 'പേര് (ഇംഗ്ലീഷ്)',
  'profile.nameMl': 'പേര് (മലയാളം)',
  'profile.addressEn': 'വിലാസം (ഇംഗ്ലീഷ്)',
  'profile.addressMl': 'വിലാസം (മലയാളം)',
  'profile.district': 'ജില്ല',
  'profile.pin': 'പിൻ കോഡ്',
  'profile.phone': 'ഓഫീസ് ഫോൺ',
  'profile.email': 'ഓഫീസ് ഇമെയിൽ',
  'profile.registrations': 'രജിസ്ട്രേഷനുകൾ',
  'profile.waqf': 'വഖഫ് ബോർഡ് രജിസ്ട്രേഷൻ നമ്പർ',
  'profile.waqfHint': 'രസീതുകളിലും സർട്ടിഫിക്കറ്റുകളിലും അച്ചടിക്കും.',
  'profile.reg12a': '12A രജിസ്ട്രേഷൻ',
  'profile.reg80g': '80G രജിസ്ട്രേഷൻ',
  'profile.taxHint': 'നൽകിയാൽ സംഭാവന രസീതുകളിൽ അച്ചടിക്കും.',
  'profile.colour': 'നിങ്ങളുടെ നിറം',
  'profile.colourHex': 'നിറ കോഡ് (ഉദാ. #1F7A6D)',
  'profile.colourHint': 'നിങ്ങളുടെ മുദ്രയുടെ ബാഡ്ജിൽ ഉപയോഗിക്കും. വെള്ളയിൽ വായിക്കാൻ കഴിയുന്നത്ര കടുപ്പം വേണം (4.5 : 1).',
  'profile.preview': 'വെള്ളയിലെ വ്യക്തത',
  'profile.mark': 'മഹല്ല് മുദ്ര',
  'profile.markHint': '{{kb}} KB വരെയുള്ള PNG അല്ലെങ്കിൽ JPEG; സൈഡ് പാനലിൽ കാണിക്കും, രസീതുകളിലും സർട്ടിഫിക്കറ്റുകളിലും അച്ചടിക്കും.',
  'profile.noMark': 'ഇതുവരെ മുദ്രയില്ല.',
  'profile.markFile': 'ചിത്രം',
  'profile.upload': 'അപ്‌ലോഡ് ചെയ്യുക',
  'profile.remove': 'നീക്കുക',
  'appset.title': 'ആപ്പ് ക്രമീകരണങ്ങൾ',
  'appset.desc': 'Rabita One നിങ്ങളുടെ മഹല്ലിൽ എങ്ങനെ പ്രവർത്തിക്കണം: കുടുംബങ്ങൾക്കുള്ള സന്ദേശങ്ങളുടെ ഭാഷ, ഏതൊക്കെ സന്ദേശങ്ങൾ അയയ്ക്കണം.',
  'appset.messages': 'കുടുംബങ്ങൾക്കുള്ള സന്ദേശങ്ങൾ',
  'appset.lang': 'സന്ദേശ ഭാഷ',
  'appset.langHint': 'രസീതുകൾ, അറിയിപ്പുകൾ, ജനാസ അറിയിപ്പുകൾ ഈ ഭാഷയിൽ പോകും.',
  'appset.notifyDefault': '“രസീത് കുടുംബത്തിന് അയയ്ക്കുക” തുടക്കത്തിൽ തിരഞ്ഞെടുത്തിരിക്കും',
  'appset.on': 'അയയ്ക്കുക',
  'appset.sms': 'വാട്സ്ആപ് പരാജയപ്പെട്ടാൽ എസ്.എം.എസ്',
  'appset.locked': 'എപ്പോഴും ഓൺ',
  'appset.whatsappOnly': 'വാട്സ്ആപ് മാത്രം',
  'appset.lockedHint': 'സൈൻ-ഇൻ കോഡുകളും ജനാസ അറിയിപ്പുകളും സുരക്ഷാ സന്ദേശങ്ങളാണ്: ഇവ ഓഫ് ചെയ്യാനാവില്ല.',
  'auditlog.title': 'ഓഡിറ്റ് ലോഗ്',
  'auditlog.desc': 'മഹല്ലിലെ എല്ലാ മാറ്റങ്ങളും, ആര്, എപ്പോൾ ചെയ്തു എന്നതും. OptiFi ഉൾപ്പെടെ ആർക്കും ഇത് തിരുത്താനോ നീക്കാനോ കഴിയില്ല.',
  'auditlog.action': 'പ്രവൃത്തി',
  'auditlog.all': 'എല്ലാ പ്രവൃത്തികളും',
  'auditlog.search': 'വിവരങ്ങളിൽ തിരയുക',
  'auditlog.who': 'ആര്',
  'auditlog.what': 'എന്തിനെക്കുറിച്ച്',
  'auditlog.count': '{{n}} രേഖകൾ',
  'notice.skip.SWITCHED_OFF': 'സന്ദേശമില്ല: ആപ്പ് ക്രമീകരണങ്ങളിൽ രസീത് സന്ദേശങ്ങൾ ഓഫ് ആണ്.',

  // Announcements, notifications, approvals (pilot slice 10)
  'ann.title': 'അറിയിപ്പുകൾ',
  'ann.desc': 'വാട്സ്ആപ്പിലൂടെ മഹല്ലിനുള്ള അറിയിപ്പുകൾ. ഓരോന്നും അയയ്ക്കുന്നതിന് മുമ്പ് മറ്റൊരു കമ്മിറ്റി അംഗം അംഗീകരിക്കണം. അറിയിപ്പുകൾക്ക് സമ്മതം നൽകിയ വീടുകൾക്ക് മാത്രം അയയ്ക്കും. ജനാസ അറിയിപ്പ് ഉടൻ പോകും.',
  'ann.new': 'പുതിയ അറിയിപ്പ്',
  'ann.sendTitle': 'ഒരു വീടിന് സന്ദേശം',
  'ann.submit': 'അംഗീകാരത്തിന് അയയ്ക്കുക',
  'ann.howItGoes': 'മറ്റൊരു കമ്മിറ്റി അംഗം അംഗീകരിച്ച ശേഷം, അറിയിപ്പുകൾക്ക് സമ്മതിച്ച വീടുകൾക്ക് വാട്സ്ആപ്പിൽ പോകും. കുടുംബങ്ങൾക്ക് മലയാളത്തിൽ ലഭിക്കാൻ മലയാളത്തിലും എഴുതുക.',
  'ann.message': 'സന്ദേശം',
  'ann.titleEn': 'തലക്കെട്ട് (ഇംഗ്ലീഷ്)',
  'ann.titleMl': 'തലക്കെട്ട് (മലയാളം)',
  'ann.bodyEn': 'വാചകം (ഇംഗ്ലീഷ്)',
  'ann.bodyMl': 'വാചകം (മലയാളം)',
  'ann.to': 'ആർക്ക്',
  'ann.audience': 'അയയ്ക്കേണ്ടത്',
  'ann.approve': 'അംഗീകരിച്ച് അയയ്ക്കുക',
  'ann.by': '{{name}}, {{when}}',
  'ann.approvedBy': 'അംഗീകരിച്ചത് {{name}}',
  'ann.reached': '{{n}} വീടുകളിലേക്ക് അയച്ചു',
  'ann.skippedConsent': '{{n}} വീടുകൾ അറിയിപ്പുകൾക്ക് സമ്മതിച്ചിട്ടില്ല',
  'ann.skippedPhone': '{{n}} വീടുകൾക്ക് മൊബൈൽ നമ്പറില്ല',
  'ann.none': 'ഇതുവരെ അറിയിപ്പുകളില്ല.',
  'audience.ALL': 'മഹല്ല് മുഴുവൻ',
  'audience.WARDS': 'ചില വാർഡുകൾ',
  'audience.PRAVASI': 'വിദേശത്ത് അംഗങ്ങളുള്ള വീടുകൾ',
  'audience.HOUSE': 'ഒരു വീട്',
  'astate.PENDING': 'അംഗീകാരത്തിനായി കാത്തിരിക്കുന്നു',
  'astate.SENT': 'അയച്ചു',
  'astate.REJECTED': 'അയച്ചില്ല',
  'janaza.title': 'ജനാസ അറിയിപ്പ്',
  'janaza.badge': 'ജനാസ',
  'janaza.send': 'ഇപ്പോൾ അയയ്ക്കുക',
  'janaza.hint': 'അംഗീകാരത്തിനായി കാത്തിരിക്കാതെ, സമ്മതം നൽകിയ രജിസ്റ്ററിലെ എല്ലാ വീടുകളിലേക്കും വാട്സ്ആപ്പിലും പിന്നെ എസ്.എം.എസിലും ഉടൻ പോകും. ഇത് നിശബ്ദമാക്കാനാവില്ല. ആദ്യം രജിസ്റ്ററിൽ മരണം രേഖപ്പെടുത്തുക.',
  'janaza.person': 'മരണപ്പെട്ടയാൾ',
  'janaza.details': 'ജനാസ',
  'janaza.prayerAt': 'ജനാസ നമസ്കാര സമയം',
  'janaza.prayerPlace': 'ജനാസ നമസ്കാര സ്ഥലം',
  'notif.title': 'അറിയിപ്പുകൾ',
  'notif.desc': 'നിങ്ങളുടെ ശ്രദ്ധ ആവശ്യമുള്ള കാര്യങ്ങൾ.',
  'notif.markAll': 'എല്ലാം വായിച്ചതായി അടയാളപ്പെടുത്തുക',
  'notif.new': 'പുതിയത്',
  'notif.none': 'അറിയിപ്പുകളില്ല.',
  'notif.unread': '{{n}} വായിക്കാത്ത അറിയിപ്പുകൾ',
  'notif.CERT_TO_SIGN': '{{name}} ന്റെ സർട്ടിഫിക്കറ്റ് നിങ്ങളുടെ ഒപ്പിനായി കാത്തിരിക്കുന്നു',
  'notif.ANNOUNCEMENT_TO_APPROVE': '“{{title}}” എന്ന അറിയിപ്പ് അംഗീകാരത്തിനായി കാത്തിരിക്കുന്നു',
  'notif.PRIVACY_REQUEST': 'സ്വകാര്യതാ അപേക്ഷ {{requestNo}} ലഭിച്ചു',
  'notif.JANAZA_SENT': '{{name}} ന്റെ ജനാസ അറിയിപ്പ് അയച്ചു',
  'inbox.title': 'അംഗീകാരങ്ങൾ',
  'inbox.desc': 'നിങ്ങളുടെ ഇപ്പോഴത്തെ റോളിൽ നിങ്ങൾക്കായി കാത്തിരിക്കുന്നവ: ഒപ്പുകൾ, അംഗീകാരങ്ങൾ, മറുപടി നൽകേണ്ട അപേക്ഷകൾ.',
  'inbox.none': 'നിങ്ങൾക്കായി ഒന്നും കാത്തിരിക്കുന്നില്ല.',
  'inbox.CERT_SIGNATURE': '{{label}} ന്റെ സർട്ടിഫിക്കറ്റിൽ ഒപ്പിടുക',
  'inbox.ANNOUNCEMENT_APPROVAL': '“{{label}}” എന്ന അറിയിപ്പ് അംഗീകരിക്കുക',
  'inbox.PRIVACY_REQUEST': 'സ്വകാര്യതാ അപേക്ഷ {{label}} ന് മറുപടി നൽകുക',
  'inbox.FAILED_MESSAGES': '{{label}} സന്ദേശങ്ങൾ എത്തിക്കാനായില്ല',
  'template.ANNOUNCEMENT': 'അറിയിപ്പ്',
  'template.JANAZA_ALERT': 'ജനാസ അറിയിപ്പ്',

  // Certificates (pilot slice 9)
  'cert.requestsTitle': 'സർട്ടിഫിക്കറ്റ് അപേക്ഷകൾ',
  'cert.requestsDesc': 'അപേക്ഷ രേഖപ്പെടുത്തുക; തുടർന്ന് രണ്ട് വ്യത്യസ്ത ഒപ്പുവയ്ക്കുന്നവർ ഒപ്പിടുന്നു. രണ്ടാമത്തെ ഒപ്പോടെ നമ്പർ സഹിതം സർട്ടിഫിക്കറ്റ് നൽകുന്നു; അൽപസമയത്തിനകം PDF തയ്യാറാകും.',
  'cert.new': 'പുതിയ അപേക്ഷ',
  'cert.record': 'അപേക്ഷ രേഖപ്പെടുത്തുക',
  'cert.section': 'ആർക്ക്, എന്ത്',
  'cert.type': 'സർട്ടിഫിക്കറ്റ്',
  'cert.deceasedHint': 'മരണപ്പെട്ടതായി രേഖപ്പെടുത്തിയവരെ മാത്രം കാണിക്കുന്നു. ആദ്യം രജിസ്റ്ററിൽ മരണം രേഖപ്പെടുത്തുക.',
  'cert.purpose': 'ആവശ്യം',
  'cert.purposeHint': 'ഉദാ: പാസ്പോർട്ട്, സ്കൂൾ പ്രവേശനം, ബാങ്ക് അക്കൗണ്ട്.',
  'cert.spouse': 'വധു / വരൻ',
  'cert.spouseName': 'വധുവിന്റെ / വരന്റെ പേര്',
  'cert.spouseMahallu': 'വധുവിന്റെ / വരന്റെ മഹല്ല്',
  'cert.nikahDate': 'നികാഹ് തീയതി',
  'cert.nikahNote': 'തദ്ദേശ സ്ഥാപനത്തിലെ വിവാഹ രജിസ്ട്രേഷന് പകരമല്ലെന്ന് സർട്ടിഫിക്കറ്റിൽ പറയും.',
  'cert.dateOfDeath': 'മരണ തീയതി',
  'cert.placeOfDeath': 'മരണ സ്ഥലം',
  'cert.burialDate': 'ഖബറടക്ക തീയതി',
  'cert.burialPlace': 'ഖബറടക്ക സ്ഥലം',
  'cert.died': 'മരണം',
  'cert.buried': 'ഖബറടക്കം',
  'cert.note': 'കുറിപ്പ്',
  'cert.signatures': '2 ൽ {{n}} ഒപ്പുകൾ',
  'cert.sign': 'ഒപ്പിടുക',
  'cert.details': 'വിവരങ്ങൾ',
  'cert.requestedBy': 'അപേക്ഷ രേഖപ്പെടുത്തിയത്',
  'cert.arrearsInfo': 'വിവരത്തിന് മാത്രം; നിരസിക്കാനുള്ള കാരണമല്ല.',
  'cert.rejectHint': 'ഈ കാരണത്തോടെ അപേക്ഷ അവസാനിക്കും. വീണ്ടും തുടങ്ങാൻ പുതിയ അപേക്ഷ രേഖപ്പെടുത്തുക.',
  'cert.none': 'ഇവിടെ ഒന്നുമില്ല.',
  'cert.issuedTitle': 'നൽകിയ സർട്ടിഫിക്കറ്റുകൾ',
  'cert.issuedDesc': 'മഹല്ല് നൽകിയ എല്ലാ സർട്ടിഫിക്കറ്റുകളും. ഒന്നും മാറ്റുകയോ നീക്കുകയോ ഇല്ല; തെറ്റായത് കാരണത്തോടെ പിൻവലിക്കും, QR പേജിൽ അത് കാണിക്കും.',
  'cert.serial': 'നമ്പർ',
  'cert.issued': 'നൽകിയത്',
  'cert.withdraw': 'പിൻവലിക്കുക',
  'cert.withdrawHint': 'സർട്ടിഫിക്കറ്റ് പിൻവലിച്ചതായി രജിസ്റ്ററിൽ നിലനിൽക്കും. QR സ്കാൻ ചെയ്യുന്നവർക്ക് ഇത് പിൻവലിച്ചതായി കാണാം.',
  'ctype.MEMBERSHIP': 'അംഗത്വ സർട്ടിഫിക്കറ്റ്',
  'ctype.NIKAH_NOC': 'നികാഹ് നിരാക്ഷേപ സാക്ഷ്യപത്രം',
  'ctype.DEATH_BURIAL': 'മരണ-ഖബറടക്ക രേഖ',
  'creq.REQUESTED': 'ഒപ്പുകൾക്കായി കാത്തിരിക്കുന്നു',
  'creq.ISSUED': 'നൽകി',
  'creq.REJECTED': 'നിരസിച്ചു',
  'cstate.ISSUED': 'സാധു',
  'cstate.WITHDRAWN': 'പിൻവലിച്ചു',
  'pdfstate.PENDING': 'പ്രിന്റ് ചെയ്യുന്നു',
  'pdfstate.READY': 'തയ്യാർ',
  'pdfstate.FAILED': 'പരാജയപ്പെട്ടു',
  'verify.title': 'സർട്ടിഫിക്കറ്റ് പരിശോധന',
  'verify.notFound': 'ഈ കോഡുമായി യോജിക്കുന്ന സർട്ടിഫിക്കറ്റില്ല. QR കോഡ് മുഴുവനായി സ്കാൻ ചെയ്തോ എന്ന് നോക്കുക.',
  'verify.genuine': 'ഈ സർട്ടിഫിക്കറ്റ് താഴെയുള്ള മഹല്ല് നൽകിയതും സാധുവുമാണ്.',
  'verify.withdrawn': 'ഈ സർട്ടിഫിക്കറ്റ് താഴെയുള്ള മഹല്ല് നൽകിയതാണ്, എന്നാൽ {{date}} ന് പിൻവലിച്ചു. ഇപ്പോൾ സാധുവല്ല.',
  'verify.mahallu': 'മഹല്ല്',
  'verify.hint': 'നമ്പറും പേരും കടലാസിലുള്ളതുമായി ഒത്തുനോക്കുക. SHA-256 മഹല്ല് നൽകിയ PDF ഫയലുമായി യോജിക്കും.',

  // Messages (pilot slice 8)
  'nav.communication.delivery': 'ഡെലിവറി ലോഗ്',
  'delivery.title': 'ഡെലിവറി ലോഗ്',
  'delivery.desc': 'Rabita One കുടുംബങ്ങൾക്ക് അയച്ച എല്ലാ സന്ദേശങ്ങളും: ആദ്യം വാട്സ്ആപ്, അത് എത്തിയില്ലെങ്കിൽ എസ്.എം.എസ്. സൈൻ-ഇൻ കോഡുകൾ ഇവിടെ ഇല്ല; അവ സൂക്ഷിക്കാറില്ല.',
  'delivery.all': 'എല്ലാം',
  'delivery.when': 'എപ്പോൾ',
  'delivery.what': 'സന്ദേശം',
  'delivery.to': 'ആർക്ക്',
  'delivery.channel': 'വഴി',
  'delivery.lang': 'ഭാഷ',
  'delivery.steps': '{{n}} ഘട്ടങ്ങൾ',
  'delivery.hide': 'ഘട്ടങ്ങൾ മറയ്ക്കുക',
  'delivery.retry': 'വീണ്ടും അയയ്ക്കുക',
  'delivery.none': 'ഇവിടെ സന്ദേശങ്ങളൊന്നുമില്ല.',
  'delivery.templates': 'സന്ദേശ മാതൃകകൾ',
  'delivery.templatesHint': 'OptiFi ഇവ വാട്സ്ആപ്പിലും (Meta) DLT എസ്.എം.എസ് രജിസ്ട്രിയിലും രജിസ്റ്റർ ചെയ്യുന്നു. മാതൃക അംഗീകരിച്ചാൽ മാത്രമേ ആ വഴി ഉപയോഗിക്കൂ; അതുവരെ സന്ദേശങ്ങൾ കാത്തിരിക്കും അല്ലെങ്കിൽ മറ്റേ വഴി പോകും.',
  'delivery.wording': 'വാചകം',
  'template.SIGN_IN_CODE': 'സൈൻ-ഇൻ കോഡ്',
  'template.RECEIPT_ISSUED': 'രസീത്',
  'channel.pending': 'ഇതുവരെ അയച്ചില്ല',
  'mstatus2.QUEUED': 'കാത്തിരിക്കുന്നു',
  'mstatus2.SENDING': 'അയയ്ക്കുന്നു',
  'mstatus2.SENT': 'അയച്ചു',
  'mstatus2.DELIVERED': 'എത്തി',
  'mstatus2.READ': 'വായിച്ചു',
  'mstatus2.FAILED': 'പരാജയപ്പെട്ടു',
  'mevent.QUEUED': 'ക്യൂവിൽ ചേർത്തു',
  'mevent.ATTEMPT': 'അയയ്ക്കുന്നു',
  'mevent.SENT': 'അയച്ചു',
  'mevent.DELIVERED': 'എത്തി',
  'mevent.READ': 'വായിച്ചു',
  'mevent.RETRY': 'വീണ്ടും ശ്രമിക്കും',
  'mevent.FALLBACK': 'അടുത്ത വഴിയിലേക്ക് മാറ്റി',
  'mevent.FAILED': 'പരാജയപ്പെട്ടു',
  'mevent.REQUEUED': 'വീണ്ടും ക്യൂവിൽ',
  'tstatus.DRAFT': 'കരട്',
  'tstatus.SUBMITTED': 'സമർപ്പിച്ചു',
  'tstatus.APPROVED': 'അംഗീകരിച്ചു',
  'tstatus.REJECTED': 'നിരസിച്ചു',
  'tstatus.PAUSED': 'നിർത്തിവച്ചു',
  'collect.notify': 'രസീത് കുടുംബത്തിന് വാട്സ്ആപ്പിൽ അയയ്ക്കുക (കിട്ടിയില്ലെങ്കിൽ എസ്.എം.എസ്)',
  'notice.queued': 'രസീത് {{to}} ലേക്ക് അയയ്ക്കും.',
  'notice.short': '{{channel}} · {{status}}',
  'notice.skip.NOT_REQUESTED': 'സന്ദേശം അയച്ചില്ല.',
  'notice.skip.NO_HOUSE': 'സന്ദേശമില്ല: സംഭാവന നൽകിയയാൾ രജിസ്റ്ററിൽ ഇല്ല.',
  'notice.skip.NO_PHONE': 'സന്ദേശമില്ല: വീട്ടിൽ ആർക്കും മൊബൈൽ നമ്പറില്ല.',
  'notice.skip.NO_CONSENT': 'സന്ദേശമില്ല: വരിസംഖ്യക്ക് വീട് സമ്മതം നൽകിയിട്ടില്ല.',

  // Varisankhya (pilot slice 7)
  'collect.title': 'പിരിക്കുക',
  'collect.pageTitle': 'പണം സ്വീകരിക്കുക',
  'collect.pageDesc': 'വീട് കണ്ടെത്തി നമ്പറിട്ട രസീത് നൽകുക. രജിസ്റ്ററിൽ ഇല്ലാത്തവരുടെ സംഭാവനയ്ക്ക് പേര് മാത്രം മതി.',
  'collect.donation': 'വീടില്ലാത്ത സംഭാവന',
  'collect.donationTitle': 'സംഭാവന',
  'collect.find': 'വീട് കണ്ടെത്തുക',
  'collect.section': 'പണമടവ്',
  'collect.fund': 'ഫണ്ട്',
  'collect.amount': 'തുക (₹)',
  'collect.amountHint': 'ഏറ്റവും പഴയ കുടിശ്ശിക മാസങ്ങൾ ആദ്യം അടയ്ക്കുന്നു.',
  'collect.ahead': 'മുൻകൂർ മാസങ്ങൾ',
  'collect.aheadHint': 'ഇത്ര മാസം മുൻകൂറായും അടയ്ക്കുക.',
  'collect.method': 'അടച്ച വിധം',
  'collect.reference': 'റഫറൻസ്',
  'collect.receivedOn': 'ലഭിച്ച തീയതി',
  'collect.note': 'കുറിപ്പ്',
  'collect.payer': 'സംഭാവന നൽകിയയാളുടെ പേര്',
  'collect.issue': 'രസീത് നൽകുക',
  'collect.issuedTitle': 'രസീത് നൽകി',
  'collect.issued': '{{amount}} ന് രസീത് {{no}} നൽകി.',
  'collect.forMonths': 'മാസങ്ങൾ: {{months}}',
  'collect.print': 'രസീത് പ്രിന്റ് ചെയ്യുക',
  'collect.outstanding': 'കുടിശ്ശിക {{amount}} ({{months}} മാസം).',
  'collect.nothingDue': 'ഇപ്പോൾ ഒന്നും അടയ്ക്കാനില്ല.',
  'collect.monthly': 'മാസം {{amount}}',
  'method.CASH': 'പണം',
  'method.UPI': 'യു.പി.ഐ',
  'method.BANK_TRANSFER': 'ബാങ്ക് ട്രാൻസ്ഫർ',
  'method.CHEQUE': 'ചെക്ക്',
  'account.monthly': 'മാസ തുക',
  'account.arrears': 'കുടിശ്ശിക',
  'account.outstanding': 'ഇപ്പോഴത്തെ ബാക്കി',
  'account.dues': 'മാസങ്ങൾ',
  'account.noDues': 'ഈ വീടിന് ഇതുവരെ വരിസംഖ്യ ചുമത്തിയിട്ടില്ല.',
  'account.receipts': 'രസീതുകൾ',
  'account.noReceipts': 'ഇതുവരെ രസീതുകളില്ല.',
  'dues.title': 'വരിസംഖ്യയും കുടിശ്ശികയും',
  'dues.desc': 'ഓരോ മാസവും എല്ലാ വീടുകൾക്കും ആ മാസത്തെ വരിസംഖ്യ കമ്മിറ്റി ചുമത്തുന്നു. കുടിശ്ശിക വിവരത്തിന് മാത്രം; ഒരു സേവനവും തടയില്ല.',
  'dues.month': 'മാസം',
  'dues.arrearsList': '3+ മാസം കുടിശ്ശികയുള്ള വീടുകൾ',
  'dues.raisedHouses': 'ഈ മാസത്തെ വരിസംഖ്യയുള്ള വീടുകൾ',
  'dues.due': '{{month}} ലെ വരിസംഖ്യ',
  'dues.paid': 'അടച്ചത്',
  'dues.unpaid': 'ഇനിയും അടയ്ക്കാത്തത്',
  'dues.raiseTitle': '{{month}} ലെ വരിസംഖ്യ ചുമത്തുക',
  'dues.raiseHint': '{{n}} സജീവ വീടുകൾക്ക് ഈ മാസത്തെ വരിസംഖ്യ ഇതുവരെ ഇല്ല. വീണ്ടും ചെയ്താലും ഒരു വീടിന് ഒരേ മാസം രണ്ടുതവണ വരില്ല.',
  'dues.allRaised': 'എല്ലാ സജീവ വീടുകൾക്കും ഈ മാസത്തെ വരിസംഖ്യ ഉണ്ട്.',
  'dues.raise': 'വരിസംഖ്യ ചുമത്തുക',
  'dues.raised': '{{n}} വീടുകൾക്ക് ചുമത്തി, ആകെ {{amount}}.',
  'rcpt.title': 'രസീതുകൾ',
  'rcpt.desc': 'നൽകിയ എല്ലാ രസീതുകളും. രസീതുകൾ നീക്കം ചെയ്യില്ല: തെറ്റുണ്ടെങ്കിൽ കാരണത്തോടെ റദ്ദാക്കും, പട്ടികയിൽ നിലനിൽക്കും.',
  'rcpt.allFunds': 'എല്ലാ ഫണ്ടുകളും',
  'rcpt.status': 'നില',
  'rcpt.allStatus': 'നൽകിയതും റദ്ദാക്കിയതും',
  'rcpt.ISSUED': 'നൽകി',
  'rcpt.CANCELLED': 'റദ്ദാക്കി',
  'rcpt.from': 'മുതൽ',
  'rcpt.to': 'വരെ',
  'rcpt.search': 'രസീത്, വീട് അല്ലെങ്കിൽ പേര്',
  'rcpt.totals': '{{n}} രസീതുകൾ; നൽകിയവയുടെ ആകെ {{amount}}.',
  'rcpt.no': 'രസീത് നമ്പർ',
  'rcpt.date': 'തീയതി',
  'rcpt.payer': 'ലഭിച്ചത്',
  'rcpt.by': 'സ്വീകരിച്ചത്',
  'rcpt.cancel': 'രസീത് റദ്ദാക്കുക',
  'rcpt.cancelHint': 'രസീത് റദ്ദാക്കിയതായി രജിസ്റ്ററിൽ നിലനിൽക്കും; {{amount}} കണക്കിൽ വരില്ല. അത് അടച്ച മാസങ്ങൾ വീണ്ടും കുടിശ്ശികയാകും.',
  'rcpt.reason': 'കാരണം',
  'rcpt.none': 'യോജിക്കുന്ന രസീതുകളില്ല.',
  'rcpt.prev': 'മുമ്പത്തേത്',
  'rcpt.next': 'അടുത്തത്',
  'rcpt.page': '{{pages}} ൽ {{page}} പേജ്',
  'plans.title': 'നിരക്ക് പ്ലാനുകളും ഫണ്ടുകളും',
  'plans.desc': 'ഓരോ പ്ലാനിന്റെയും മാസ വരിസംഖ്യയും മഹല്ല് പിരിക്കുന്ന ഫണ്ടുകളും.',
  'plans.plans': 'പ്ലാനുകൾ',
  'plans.hint': 'ഓരോ വീടും സ്വന്തം മാസ തുക അടയ്ക്കുന്നു, അത് പ്ലാനിൽ നിന്ന് തുടങ്ങുന്നു. പ്ലാൻ മാറ്റുമ്പോൾ പഴയ തുക അടയ്ക്കുന്ന വീടുകളെയും മാറ്റാം; ചുമത്തിയ വരിസംഖ്യ മാറില്ല.',
  'plans.houses': 'സജീവ വീടുകൾ',
  'plans.monthly': 'മാസം (₹)',
  'plans.apply': 'പഴയ തുകയുള്ള വീടുകൾക്കും',
  'funds.title': 'ഫണ്ടുകൾ',
  'funds.hint': 'വരിസംഖ്യയാണ് പ്രതിമാസ ഫണ്ട്. മറ്റ് ഫണ്ടുകൾ സംഭാവനകൾ സ്വീകരിക്കുന്നു; അടച്ച ഫണ്ട് പുതിയ പണം സ്വീകരിക്കില്ല.',
  'funds.add': 'ഫണ്ട് ചേർക്കുക',
  'funds.section': 'ഫണ്ട്',
  'funds.code': 'കോഡ്',
  'funds.codeHint': 'വലിയ അക്ഷരങ്ങൾ, ഉദാ. RAMADAN. പിന്നീട് മാറ്റാനാവില്ല.',
  'funds.open': 'തുറന്നത്',
  'funds.closed': 'അടച്ചത്',
  'funds.dues': 'പ്രതിമാസ വരിസംഖ്യ',
  'funds.close': 'അടയ്ക്കുക',
  'funds.reopen': 'വീണ്ടും തുറക്കുക',
  'print.receipt': 'രസീത്',
  'print.months': 'അടച്ച മാസങ്ങൾ',
  'print.footer': 'നന്ദി. ഈ രസീത് സൂക്ഷിക്കുക; ഇതിന്റെ നമ്പർ പണമടവ് ഉറപ്പാക്കുന്നു.',

  // Register spreadsheet and data health (pilot slice 6)
  'mm.preparing': 'സ്‌പ്രെഡ്‌ഷീറ്റ് തയ്യാറാക്കുന്നു…',
  'nav.register.dataHealth': 'ഡാറ്റാ പരിശോധന',
  'import.title': 'എക്സൽ ഫയലിൽ നിന്ന് ചേർക്കുക',
  'import.step1': 'മാതൃക ഡൗൺലോഡ് ചെയ്യുക. കോളങ്ങളും ഓരോന്നും പൂരിപ്പിക്കേണ്ട വിധവും വാർഡ് കോഡുകളും അതിലുണ്ട്.',
  'import.template': 'മാതൃക',
  'import.step2': 'ഓരോ അംഗത്തിനും ഒരു വരി. ഒരേ വീട് കീ ഉള്ള വരികൾ ഒരു വീടാകും; ഒരു HEAD മാത്രം.',
  'import.step3': 'ഫയൽ പരിശോധിക്കുക. എല്ലാ വരികളും ശരിയാകുന്നതുവരെ ഒന്നും സേവ് ചെയ്യില്ല; പിന്നെ ഫയൽ മുഴുവനായി ഒരുമിച്ച് ചേർക്കും.',
  'import.section': 'നിങ്ങളുടെ ഫയൽ',
  'import.file': 'എക്സൽ ഫയൽ (.xlsx)',
  'import.fileHint': '{{mb}} MB, {{rows}} വരികൾ വരെ. ചേർക്കുന്ന വീടുകളുടെ സമ്മതം തീർപ്പാക്കാനുള്ളതായി തുടങ്ങും.',
  'import.check': 'ഫയൽ പരിശോധിക്കുക',
  'import.apply': '{{houses}} വീടുകൾ, {{members}} അംഗങ്ങൾ ചേർക്കുക',
  'import.working': 'ഫയൽ വായിക്കുന്നു…',
  'import.problems': 'എന്തെങ്കിലും ചേർക്കുന്നതിന് മുമ്പ് {{n}} പ്രശ്നങ്ങൾ പരിഹരിക്കണം.',
  'import.moreProblems': 'കാണിക്കാത്ത {{n}} എണ്ണം കൂടി. ഇവ പരിഹരിച്ച് വീണ്ടും പരിശോധിക്കുക.',
  'import.row': 'വരി',
  'import.column': 'കോളം',
  'import.problem': 'പ്രശ്നം',
  'import.ready': 'ഫയൽ ശരിയാണ്: {{houses}} വീടുകളും {{members}} അംഗങ്ങളും ചേർക്കാൻ തയ്യാർ.',
  'import.done': '{{houses}} വീടുകളും {{members}} അംഗങ്ങളും ചേർത്തു.',
  'import.maybeDuplicates': '{{n}} എണ്ണം രജിസ്റ്ററിൽ ഇതിനകം ഉണ്ടാകാം',
  'import.duplicateLine': 'വരി {{row}} (വീട് കീ {{key}}) വീട് {{houseNo}} പോലെ തോന്നുന്നു: ഒരേ വാർഡ്, വീട്ടുപേര്, ഗൃഹനാഥൻ.',
  'health.title': 'ഡാറ്റാ പരിശോധന',
  'health.desc': 'രജിസ്റ്റർ നിയമം തെറ്റിക്കുന്ന രേഖകളും വീണ്ടും നോക്കേണ്ടവയും. തിരുത്താൻ വീട് തുറക്കുക.',
  'health.loading': 'രജിസ്റ്റർ പരിശോധിക്കുന്നു…',
  'health.toFix': '{{n}} രേഖകൾ തിരുത്തണം.',
  'health.allClear': 'ഒരു രേഖയും രജിസ്റ്റർ നിയമം തെറ്റിക്കുന്നില്ല. താഴെയുള്ളവ ഒന്ന് നോക്കാം.',
  'health.levelFix': 'തിരുത്തുക',
  'health.levelReview': 'പരിശോധിക്കുക',
  'health.more': '{{n}} എണ്ണം കൂടി; ആദ്യ {{limit}} എണ്ണം കാണിക്കുന്നു.',
  'health.NO_HEAD': 'ഗൃഹനാഥനില്ലാത്ത വീടുകൾ',
  'health.NO_HEAD.why': 'സജീവമായ ഓരോ വീടിനും ജീവിച്ചിരിക്കുന്ന ഒരു ഗൃഹനാഥൻ വേണം.',
  'health.YOUNG_HEAD': '18 വയസ്സിൽ താഴെയുള്ള ഗൃഹനാഥൻ',
  'health.YOUNG_HEAD.why': 'സമ്മതം നൽകുന്നത് പ്രായപൂർത്തിയായവരാണ്; ജനന വർഷമോ ഗൃഹനാഥനെയോ പരിശോധിക്കുക.',
  'health.NO_PHONE': 'മൊബൈൽ നമ്പറില്ലാത്ത വീടുകൾ',
  'health.NO_PHONE.why': 'വീട്ടിൽ ആർക്കും രസീതുകളോ അറിയിപ്പുകളോ ലഭിക്കില്ല.',
  'health.AWAY_NO_PLACE': 'രാജ്യം/സംസ്ഥാനം ഇല്ലാതെ പുറത്ത് താമസം',
  'health.AWAY_NO_PLACE.why': 'ഓരോ അംഗവും എവിടെ താമസിക്കുന്നു എന്ന് പ്രവാസി രജിസ്റ്ററിന് അറിയണം.',
  'health.DUPLICATE_MEMBER': 'ഒരു വീട്ടിൽ ഒരേ ആൾ രണ്ടുതവണ',
  'health.DUPLICATE_MEMBER.why': 'ഒരു വീട്ടിൽ ഒരേ പേരും ജനന വർഷവും. അധികമുള്ളതിന് ശരിയായ നില നൽകുക.',
  'health.DUPLICATE_HOUSE': 'ഇരട്ടിച്ചിരിക്കാവുന്ന വീടുകൾ',
  'health.DUPLICATE_HOUSE.why': 'ഒരേ വാർഡ്, വീട്ടുപേര്, ഗൃഹനാഥൻ. പലപ്പോഴും ഒരേ കുടുംബം രണ്ടുതവണ ചേർത്തതാണ്.',
  'health.NO_BIRTH_YEAR': 'ജനന വർഷമില്ലാത്ത അംഗങ്ങൾ',
  'health.NO_BIRTH_YEAR.why': 'മദ്രസ, സർട്ടിഫിക്കറ്റുകൾ, സമ്മതം നൽകാവുന്നവർ എന്നിവയ്ക്ക് ആവശ്യം.',

  // Privacy (pilot slice 5)
  'tab.consent': 'സമ്മതം',
  'consent.WITHDRAWN': 'പിൻവലിച്ചു',
  'consent.NONE': 'രേഖപ്പെടുത്തിയിട്ടില്ല',
  'purpose.REGISTER': 'രജിസ്റ്റർ',
  'purpose.VARISANKHYA': 'വരിസംഖ്യ',
  'purpose.CERTIFICATES': 'സർട്ടിഫിക്കറ്റുകൾ',
  'purpose.MADRASA': 'മദ്രസ',
  'purpose.NOTICES': 'അറിയിപ്പുകളും ഓർമപ്പെടുത്തലുകളും',
  'purpose.WELFARE': 'ക്ഷേമം',
  'cmethod.PAPER_FORM': 'ഒപ്പിട്ട ഫോം',
  'cmethod.IN_PERSON': 'നേരിട്ട്',
  'cmethod.PHONE_CALL': 'ഫോൺ വിളി',
  'cmethod.IMPORTED': 'പഴയ രജിസ്റ്ററിൽ നിന്ന്',
  'consent.noNotice': 'സ്വകാര്യതാ അറിയിപ്പ് ഇതുവരെ പ്രസിദ്ധീകരിച്ചിട്ടില്ല. സമ്മതം രേഖപ്പെടുത്തുന്നതിന് മുമ്പ് ക്രമീകരണങ്ങൾ › സ്വകാര്യത എന്നതിൽ അത് പ്രസിദ്ധീകരിക്കുക.',
  'consent.give': 'സമ്മതം രേഖപ്പെടുത്തുക',
  'consent.withdraw': 'പിൻവലിക്കൽ രേഖപ്പെടുത്തുക',
  'consent.section': 'സമ്മതം',
  'consent.purposes': 'ആവശ്യങ്ങൾ',
  'consent.purpose': 'ആവശ്യം',
  'consent.person': 'കുടുംബാംഗം',
  'consent.personHint': 'വീട്ടിലെ പ്രായപൂർത്തിയായ അംഗം, സാധാരണയായി ഗൃഹനാഥൻ.',
  'consent.method': 'എങ്ങനെ നൽകി',
  'consent.note': 'കുറിപ്പ്',
  'consent.state': 'നില',
  'consent.notice': 'അറിയിപ്പ്',
  'consent.noticeV': 'പതിപ്പ് {{n}}',
  'consent.when': 'രേഖപ്പെടുത്തിയത്',
  'consent.history': 'ചരിത്രം',
  'consent.giveHint': 'സ്വകാര്യതാ അറിയിപ്പ് പതിപ്പ് {{n}} അനുസരിച്ച് രേഖപ്പെടുത്തുന്നു. ആദ്യം അറിയിപ്പ് കുടുംബത്തെ കാണിക്കുകയോ വായിച്ചു കേൾപ്പിക്കുകയോ ചെയ്യുക.',
  'consent.olderNotice': 'പഴയ അറിയിപ്പിനാണ് നൽകിയത്',
  'consent.pickPurpose': 'കുറഞ്ഞത് ഒരു ആവശ്യമെങ്കിലും തിരഞ്ഞെടുക്കുക.',
  'member.erasure': 'മായ്ക്കൽ അപേക്ഷ',
  'member.erased': 'ബന്ധപ്പെടാനുള്ള വിവരങ്ങൾ മായ്ച്ചു',
  'nav.settings.privacy': 'സ്വകാര്യത',
  'nav.register.privacyRequests': 'സ്വകാര്യതാ അപേക്ഷകൾ',
  'privacy.title': 'സ്വകാര്യത',
  'privacy.desc': 'കുടുംബങ്ങളുടെ വിവരങ്ങൾ എങ്ങനെ ഉപയോഗിക്കണമെന്ന് മഹല്ലാണ് തീരുമാനിക്കുന്നത്: അവർ കാണുന്ന അറിയിപ്പ്, അവരുടെ ചോദ്യങ്ങൾക്ക് മറുപടി നൽകുന്നയാൾ, രേഖകൾ എത്ര കാലം സൂക്ഷിക്കും എന്നിവ.',
  'privacy.loading': 'സ്വകാര്യതാ ക്രമീകരണങ്ങൾ ലോഡ് ചെയ്യുന്നു…',
  'privacy.officer': 'പരാതി പരിഹാര ഓഫീസർ',
  'privacy.named': 'നിശ്ചയിച്ചു',
  'privacy.notNamed': 'ഇതുവരെ നിശ്ചയിച്ചിട്ടില്ല',
  'privacy.officerHint': 'വിവരങ്ങളെക്കുറിച്ച് കുടുംബങ്ങൾ ബന്ധപ്പെടേണ്ടയാൾ. പൊതു അറിയിപ്പിൽ കാണിക്കും.',
  'privacy.contact': 'ബന്ധപ്പെടാൻ',
  'privacy.officerName': 'പേര്',
  'privacy.officerPhone': 'മൊബൈൽ നമ്പർ',
  'privacy.officerEmail': 'ഇമെയിൽ',
  'privacy.saveOfficer': 'ഓഫീസറെ സേവ് ചെയ്യുക',
  'privacy.notice': 'സ്വകാര്യതാ അറിയിപ്പ്',
  'privacy.published': 'പതിപ്പ് {{n}} പ്രസിദ്ധീകരിച്ചത് {{date}}',
  'privacy.notPublishedShort': 'പ്രസിദ്ധീകരിച്ചിട്ടില്ല',
  'privacy.notPublished': 'സമ്മതം രേഖപ്പെടുത്തുന്നതിന് മുമ്പ് കുടുംബങ്ങൾ അറിയിപ്പ് കണ്ടിരിക്കണം. ഇംഗ്ലീഷിലും മലയാളത്തിലും എഴുതി പ്രസിദ്ധീകരിക്കുക.',
  'privacy.publicLink': 'പൊതു പേജ്',
  'privacy.newDraft': 'പുതിയ പതിപ്പ് എഴുതുക',
  'privacy.draft': 'പതിപ്പ് {{n}} കരട്',
  'privacy.newVersion': 'പുതിയ പതിപ്പ്',
  'privacy.template': 'മാതൃകയിൽ നിന്ന് നിറയ്ക്കുക',
  'privacy.templateHint': 'മഹല്ലിന്റെ പേര്, ഓഫീസർ, സൂക്ഷിക്കുന്ന കാലയളവുകൾ എന്നിവ ചേർത്ത ഒരു തുടക്കം. ഇത് നിങ്ങളുടെ രേഖയാണ്: തിരുത്തുക, നിയമോപദേശകനെക്കൊണ്ട് പരിശോധിപ്പിക്കുക, മലയാളം ഒരാളെക്കൊണ്ട് വായിപ്പിക്കുക.',
  'privacy.bodyEn': 'ഇംഗ്ലീഷിലുള്ള അറിയിപ്പ്',
  'privacy.bodyMl': 'മലയാളത്തിലുള്ള അറിയിപ്പ്',
  'privacy.saveDraft': 'കരട് സേവ് ചെയ്യുക',
  'privacy.publish': 'ഈ പതിപ്പ് പ്രസിദ്ധീകരിക്കുക',
  'privacy.publishHint': 'പ്രസിദ്ധീകരിച്ച പതിപ്പ് ഒരിക്കലും മാറില്ല; എന്തിനാണ് സമ്മതിച്ചതെന്ന് കുടുംബങ്ങൾക്ക് എപ്പോഴും കാണാം. മാറ്റം വേണമെങ്കിൽ പുതിയ പതിപ്പ് പ്രസിദ്ധീകരിക്കുക.',
  'privacy.retention': 'രേഖകൾ എത്ര കാലം സൂക്ഷിക്കും',
  'privacy.retentionHint': 'മഹല്ല് സൂക്ഷിക്കേണ്ട രേഖകളുടെ കാലയളവ് മാറ്റാനാവില്ല. മറ്റുള്ളവ കൂട്ടാം, അല്ലെങ്കിൽ കാണിച്ച ഏറ്റവും കുറഞ്ഞ കാലയളവ് വരെ കുറയ്ക്കാം. ഉപയോഗം തുടങ്ങുന്നതിന് മുമ്പ് നിയമോപദേശകൻ ഈ പട്ടിക അംഗീകരിക്കും; സ്റ്റേജിങ് തുടങ്ങുമ്പോൾ സ്വയമേവയുള്ള നീക്കം ആരംഭിക്കും.',
  'privacy.record': 'രേഖ',
  'privacy.period': 'സൂക്ഷിക്കുന്നത്',
  'privacy.basis': 'എന്തുകൊണ്ട്',
  'privacy.months': 'മാസം',
  'privacy.min': 'കുറഞ്ഞത് {{n}} മാസം',
  'privacy.custom': 'നിങ്ങളുടെ തീരുമാനം',
  'privacy.fixed': 'മാറ്റാനാവില്ല',
  'requests.title': 'സ്വകാര്യതാ അപേക്ഷകൾ',
  'requests.desc': 'വിവരങ്ങൾ മായ്ക്കാനുള്ള കുടുംബങ്ങളുടെ അപേക്ഷകൾ. ബന്ധപ്പെടാനുള്ള വിവരങ്ങൾ മായ്ക്കും; രജിസ്റ്ററിലെ വിവരങ്ങളും രസീതുകളും സർട്ടിഫിക്കറ്റുകളും നിലനിൽക്കും, കാരണം മറുപടിയിൽ പറയും.',
  'requests.new': 'മായ്ക്കൽ അപേക്ഷ',
  'requests.record': 'അപേക്ഷ രേഖപ്പെടുത്തുക',
  'requests.newHint': '{{days}} ദിവസത്തിനകം മറുപടി നൽകണം. ബന്ധപ്പെടാനുള്ള വിവരങ്ങൾ മായ്ക്കും; രജിസ്റ്ററിലെ വിവരങ്ങളും രസീതുകളും സർട്ടിഫിക്കറ്റുകളും സൂക്ഷിക്കും.',
  'requests.section': 'അപേക്ഷ',
  'requests.via': 'ലഭിച്ചത്',
  'requests.note': 'അവർ ആവശ്യപ്പെട്ടത്',
  'requests.decide': 'തീരുമാനിക്കുക',
  'requests.decision': 'തീരുമാനം',
  'requests.person': 'വ്യക്തി',
  'requests.complete': 'ബന്ധപ്പെടാനുള്ള വിവരങ്ങൾ മായ്ക്കുക',
  'requests.completeHint': 'മൊബൈൽ നമ്പർ, സ്ഥലം, ജോലി എന്നിവ ഉടൻ മായ്ക്കും. രജിസ്റ്ററിലെ വിവരങ്ങളും രസീതുകളും സർട്ടിഫിക്കറ്റുകളും നിലനിൽക്കും.',
  'requests.reject': 'നിരസിക്കുക',
  'requests.reason': 'കാരണം (കുടുംബത്തെ അറിയിക്കും)',
  'requests.decisionNote': 'കുറിപ്പ്',
  'requests.erasedFields': 'മായ്ച്ചത്: {{list}}',
  'requests.nothingToErase': 'മായ്ക്കാൻ വിവരങ്ങളൊന്നും ഉണ്ടായിരുന്നില്ല',
  'requests.show': 'കാണിക്കുക',
  'requests.filter.open': 'തുറന്നവ',
  'requests.filter.closed': 'തീർപ്പാക്കിയവ',
  'requests.filter.all': 'എല്ലാം',
  'requests.fromHouse': 'അപേക്ഷ രേഖപ്പെടുത്താൻ വീട് തുറന്ന് ആ വ്യക്തിയുടെ വരിയിലെ ഷീൽഡ് ബട്ടൺ അമർത്തുക.',
  'requests.no': 'അപേക്ഷ',
  'requests.received': 'ലഭിച്ചത്',
  'requests.due': 'മറുപടി നൽകേണ്ട തീയതി',
  'requests.status': 'നില',
  'requests.outcome': 'ഫലം',
  'requests.loading': 'അപേക്ഷകൾ ലോഡ് ചെയ്യുന്നു…',
  'requests.overdue': 'സമയം കഴിഞ്ഞു',
  'requests.none': 'ഇവിടെ അപേക്ഷകളൊന്നുമില്ല.',
  'via.IN_PERSON': 'നേരിട്ട്',
  'via.PHONE_CALL': 'ഫോൺ വിളി',
  'via.LETTER': 'കത്ത്',
  'via.EMAIL': 'ഇമെയിൽ',
  'via.WHATSAPP': 'വാട്സ്ആപ്',
  'rstatus.RECEIVED': 'തുറന്നത്',
  'rstatus.COMPLETED': 'മായ്ച്ചു',
  'rstatus.REJECTED': 'നിരസിച്ചു',
  'public.notice': 'സ്വകാര്യതാ അറിയിപ്പ്',
  'public.version': 'പതിപ്പ് {{n}} · പ്രസിദ്ധീകരിച്ചത് {{date}}',
  'public.language': 'ഭാഷ',
  'public.notFound': 'ഈ പേജ് നിലവിലില്ല.',
  'public.none': 'ഈ മഹല്ല് സ്വകാര്യതാ അറിയിപ്പ് ഇതുവരെ പ്രസിദ്ധീകരിച്ചിട്ടില്ല.',
  'public.officer': 'പരാതി പരിഹാര ഓഫീസർ',
  'public.by': 'Rabita One · OptiFi-യുടെ Mahallu Cloud',

  'soon.title': 'അടുത്ത ഘട്ടത്തിൽ വരും',
  'soon.body': 'ഈ സ്ക്രീൻ പ്രോട്ടോടൈപ്പിൽ രൂപകൽപ്പന ചെയ്തിട്ടുണ്ട്; അംഗ രജിസ്റ്ററിന് ശേഷം നിർമ്മിക്കും.',

  // OptiFi platform console and mahallu links (ADR-0040).
  'console.title': 'OptiFi പ്ലാറ്റ്ഫോം കൺസോൾ',
  'console.scope': 'പ്ലാറ്റ്ഫോം തലം · അംഗ വിവരങ്ങളില്ല',
  'console.section': 'OptiFi പ്ലാറ്റ്ഫോം',
  'console.nav.overview': 'അവലോകനം',
  'console.nav.mahallus': 'മഹല്ലുകൾ',
  'console.nav.requests': 'ഡെമോ അഭ്യർത്ഥനകൾ',
  'console.nav.operators': 'ഓപ്പറേറ്റർമാർ',
  'console.nav.activity': 'കൺസോൾ പ്രവർത്തനങ്ങൾ',
  'console.role.OWNER': 'ഉടമ',
  'console.role.SUPPORT': 'സപ്പോർട്ട്',
  'console.opStatus.ACTIVE': 'സജീവം',
  'console.opStatus.REVOKED': 'റദ്ദാക്കി',
  'console.status.TRIAL': 'ട്രയൽ',
  'console.status.LIVE': 'ലൈവ്',
  'console.status.SUSPENDED': 'നിർത്തിവെച്ചു',
  'console.status.change': 'സ്ഥിതി മാറ്റുക',
  'console.status.section': 'പുതിയ സ്ഥിതി',
  'console.status.reason': 'കാരണം',
  'console.status.reasonHint': 'കൺസോൾ ലോഗിലും മഹല്ലിന്റെ സ്വന്തം ഓഡിറ്റ് ലോഗിലും സൂക്ഷിക്കും.',
  'console.status.suspendNote': 'നിർത്തിവെച്ചാൽ ഈ മഹല്ലിന്റെ എല്ലാ സൈൻ-ഇന്നും സ്ക്രീനുകളും ഉടൻ നിലയ്ക്കും. ഒന്നും ഇല്ലാതാക്കില്ല; വീണ്ടും സജീവമാക്കിയാൽ പ്രവേശനം തിരികെ ലഭിക്കും.',
  'console.lead.NEW': 'പുതിയത്',
  'console.lead.CONTACTED': 'ബന്ധപ്പെട്ടു',
  'console.lead.CLOSED': 'അടച്ചു',
  'console.demo': 'ഡെമോ',
  'console.noAdmin': 'അഡ്മിൻ ഇല്ല',
  'console.noMemberData': 'കൺസോൾ എണ്ണങ്ങൾ മാത്രം കാണിക്കുന്നു. അംഗങ്ങളുടെ പേരുകളും ഫോൺ നമ്പറുകളും തുകകളും അതത് മഹല്ലിൽ തന്നെ നിൽക്കും.',
  'console.overview.title': 'പ്ലാറ്റ്ഫോം അവലോകനം',
  'console.overview.desc': 'Rabita One-ലെ എല്ലാ മഹല്ലുകളും, ഉപയോഗത്തിന്റെ എണ്ണങ്ങളോടെ.',
  'console.overview.mahallus': 'മഹല്ലുകൾ',
  'console.overview.total': 'എല്ലാ മഹല്ലുകളും',
  'console.overview.usage': 'മഹല്ലുകളിലെ ആകെ ഉപയോഗം',
  'console.overview.desk': 'ഡെസ്ക്',
  'console.overview.newRequests': 'പുതിയ ഡെമോ അഭ്യർത്ഥനകൾ',
  'console.col.mahallu': 'മഹല്ല്',
  'console.col.link': 'ലിങ്ക്',
  'console.col.status': 'സ്ഥിതി',
  'console.col.houses': 'വീടുകൾ',
  'console.col.members': 'അംഗങ്ങൾ',
  'console.col.receipts30d': 'രസീതുകൾ (30 ദിവസം)',
  'console.col.certificates': 'സർട്ടിഫിക്കറ്റുകൾ',
  'console.col.messages30d': 'സന്ദേശങ്ങൾ (30 ദിവസം)',
  'console.col.failed30d': 'പരാജയപ്പെട്ട സന്ദേശങ്ങൾ (30 ദിവസം)',
  'console.col.lastActivity': 'അവസാന പ്രവർത്തനം',
  'console.col.when': 'എപ്പോൾ',
  'console.col.person': 'വ്യക്തി',
  'console.col.contact': 'ബന്ധപ്പെടാൻ',
  'console.col.message': 'സന്ദേശം',
  'console.col.role': 'ചുമതല',
  'console.col.since': 'മുതൽ',
  'console.col.action': 'നടപടി',
  'console.col.detail': 'വിശദാംശം',
  'console.mahallus.title': 'മഹല്ലുകൾ',
  'console.mahallus.desc': 'ആദ്യ അഡ്മിനോടൊപ്പം ഒരു മഹല്ല് ചേർക്കുക, അല്ലെങ്കിൽ നിർത്തിവെക്കുക / വീണ്ടും സജീവമാക്കുക.',
  'console.mahallus.none': 'ഇതുവരെ മഹല്ലുകളില്ല.',
  'console.new.title': 'മഹല്ല് ചേർക്കുക',
  'console.new.save': 'മഹല്ല് സൃഷ്ടിക്കുക',
  'console.new.mahallu': 'മഹല്ല്',
  'console.new.nameEn': 'പേര് (ഇംഗ്ലീഷ്)',
  'console.new.nameMl': 'പേര് (മലയാളം)',
  'console.new.slug': 'ലിങ്ക് പേര്',
  'console.new.slugHint': 'മഹല്ലിന്റെ സ്വന്തം ലിങ്ക്: {{link}}. ചെറിയ ഇംഗ്ലീഷ് അക്ഷരങ്ങൾ, അക്കങ്ങൾ, ഹൈഫൻ; പിന്നീട് മാറ്റാനാകില്ല.',
  'console.new.slugBad': '2–63 ചെറിയ അക്ഷരങ്ങൾ, അക്കങ്ങൾ അല്ലെങ്കിൽ ഹൈഫൻ ഉപയോഗിക്കുക; app, console പോലുള്ള നീക്കിവെച്ച വാക്കുകൾ പാടില്ല.',
  'console.new.admin': 'ആദ്യ അഡ്മിൻ',
  'console.new.adminName': 'അഡ്മിന്റെ പേര്',
  'console.new.adminPhone': 'അഡ്മിന്റെ മൊബൈൽ നമ്പർ',
  'console.new.adminHint': 'രാജ്യ കോഡോടെ. ഒറ്റത്തവണ കോഡ് ഉപയോഗിച്ച് സൈൻ ഇൻ ചെയ്ത് ഓതന്റിക്കേറ്റർ സജ്ജമാക്കും.',
  'console.requests.title': 'ഡെമോ അഭ്യർത്ഥനകൾ',
  'console.requests.desc': 'rabitaone.in ഫോമിൽ നിന്നുള്ള അഭ്യർത്ഥനകൾ.',
  'console.requests.none': 'ഇതുവരെ അഭ്യർത്ഥനകളില്ല.',
  'console.requests.retention': 'മറുപടി നൽകാനായി അഭ്യർത്ഥനകൾ 12 മാസം സൂക്ഷിക്കും, പിന്നീട് ഇല്ലാതാക്കും.',
  'console.operators.title': 'ഓപ്പറേറ്റർമാർ',
  'console.operators.desc': 'ഈ കൺസോൾ തുറക്കാൻ കഴിയുന്ന OptiFi ജീവനക്കാർ.',
  'console.operators.how': 'ഓപ്പറേറ്റർമാരെ ചേർക്കുന്നതും റദ്ദാക്കുന്നതും സെർവറിൽ npm run console:operator വഴി മാത്രം; ഈ സ്ക്രീനിൽ നിന്നല്ല.',
  'console.activity.title': 'കൺസോൾ പ്രവർത്തനങ്ങൾ',
  'console.activity.desc': 'എല്ലാ കൺസോൾ നടപടികളും ഓപ്പറേറ്റർ മാറ്റങ്ങളും. ഈ ലോഗ് തിരുത്താനാകില്ല.',
  'console.activity.commandLine': 'സെർവർ കമാൻഡ് ലൈൻ',
  'console.signin.title': 'OptiFi കൺസോളിൽ സൈൻ ഇൻ ചെയ്യുക',
  'console.signin.subtitle': 'OptiFi ഓപ്പറേറ്റർമാർക്ക് മാത്രം. കോഡിന് ശേഷം ഓതന്റിക്കേറ്റർ ആപ്പ് വേണം.',
  'signin.byPhone': 'മൊബൈൽ',
  'signin.byEmail': 'ഇമെയിൽ',
  'signin.phone': 'മൊബൈൽ നമ്പർ',
  'signin.email': 'ഇമെയിൽ വിലാസം',
  'signin.country': 'രാജ്യ കോഡ്',
  'signin.visualTitle': 'നിങ്ങളുടെ മഹല്ല് ഓഫീസ്, ഓൺലൈനിൽ.',
  'signin.trust1': 'വിവരങ്ങൾ ഇന്ത്യയിൽ',
  'signin.trust2': 'കമ്മിറ്റിക്ക് രണ്ട് ഘട്ട സൈൻ-ഇൻ',
  'signin.trust3': 'മലയാളവും ഇംഗ്ലീഷും',
  'signin.footer': 'ഒറ്റത്തവണ കോഡും രണ്ട് ഘട്ട സൈൻ-ഇന്നും സംരക്ഷിക്കുന്നു · OptiFi Technologies LLP',
  'signin.visual': 'മഹല്ല് ഓഫീസ് ഓൺലൈനിൽ: രജിസ്റ്റർ, വരിസംഖ്യ, സർട്ടിഫിക്കറ്റുകൾ, അറിയിപ്പുകൾ — മലയാളത്തിലും ഇംഗ്ലീഷിലും.',
  'console.signin.visual': 'OptiFi ഓപ്പറേറ്റർമാർക്ക്. മഹല്ല് തിരിച്ചുള്ള എണ്ണങ്ങൾ മാത്രം; അംഗ വിവരങ്ങൾ അതത് മഹല്ലിൽ തന്നെ.',
  'console.signin.onlyConsole': 'ഈ അക്കൗണ്ട് ഒരു മഹല്ലല്ല, OptiFi കൺസോളാണ് തുറക്കുന്നത്.',
  'console.signin.open': 'OptiFi കൺസോൾ തുറക്കുക',

  'common.notGiven': 'നൽകിയിട്ടില്ല',
};
